import React, { FC } from 'react'
import { ToolbarButton } from '@/components/toolbar/atoms'
import { ToolbarElementProps } from '@/model/Toolbar'
import { platformShortCutLabel } from '@/utils/platform.utils'

export const ListGroup: FC<ToolbarElementProps> = ({ editor }) => {
  const toggleBulletList = () => editor.chain().focus().toggleBulletList().run()
  const toggleOrderedList = () => editor.chain().focus().toggleOrderedList().run()

  return (
    <>
      <ToolbarButton
        title={`Liste à puces (${platformShortCutLabel('$CTRL + Shift + _')})`}
        icon="UnorderedList"
        active={editor.isActive('bulletList')}
        onClick={toggleBulletList}
        testId="button-toolbar-editor-bullet_list"
      />
      <ToolbarButton
        title={`Liste numérotée (${platformShortCutLabel('$CTRL + Shift + è')})`}
        icon="OrderedList"
        active={editor.isActive('orderedList')}
        onClick={toggleOrderedList}
        testId="button-toolbar-editor-ordered_list"
      />
    </>
  )
}
